export class NextStepsConstants {
    static NEXT_STEPS_FORM_CONTROL_NAME = "nextSteps";
    static INVALID_METADATA = "Invalid metadata - Invalid next step options, please contact the system administrator";
}
